import React from 'react';
import { JustWinContent } from 'Components/Modals/Investment/JustWinDialog/JustWinContent';
import DataContainer from 'Components/UI/DataContainer';
import useRelationship from 'Hooks/useRelationship';
import PropTypes from 'prop-types';
import { noop } from 'Helpers/PropTypes';

const JustWinContainer = ({ relationship, onSubmit }) => {
  const {
    isInitializing,
    loadingError,
    collection,
  } = useRelationship(
    relationship,
  );
  return (
    <DataContainer
      component={JustWinContent}
      loading={isInitializing}
      loadingError={loadingError}
      componentProps={{
        collection,
        resource: collection?.resources()?.head(),
        onSubmit,
      }}
    />
  );
};

JustWinContainer.defaultProps = {
  onSubmit: noop,
};
JustWinContainer.propTypes = {
  relationship: PropTypes.object.isRequired,
  onSubmit: PropTypes.func,
};

export { JustWinContainer };
